module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 22
// module chunks = 0 1